import React from "react";
import { isArrayWithItems } from "./arrayHelper";

export const replaceHTMLText = html => {
    if (html) {
        const htmlStrings = html.split(/\r\n|[\n\v\f\r\x85\u2028\u2029]/);

        if (isArrayWithItems(htmlStrings)) {
            return (
                <React.Fragment>
                    {
                        React.Children.toArray(
                            htmlStrings.map(htmlString => {
                                if (!htmlString) {
                                    return <br />
                                }

                                let htmlResult = [];

                                htmlResult = [
                                    ...htmlResult,
                                    replaceHTMLString(htmlString)
                                ];

                                return (
                                    <div>
                                        {React.Children.toArray(htmlResult)}
                                    </div>
                                );
                            })
                        )
                    }
                </React.Fragment>
            );
        }
    }
};

export const replaceHTMLString = htmlString => {
    if (htmlString) {
        const mainRegex = /(.*)?({(u|b|i|link):(.+?)})+?(.*)?/;
        const mainResult = mainRegex.exec(htmlString);

        if (mainResult) {
            let result = [];

            if (mainResult[1]) {
                result = [
                    ...result,
                    ...replaceHTMLString(mainResult[1])
                ];
            }

            if (mainResult[2]) {
                if (mainResult[3] === 'i') {
                    result = [
                        ...result,
                        <i key={result.length}>{mainResult[4]}</i>
                    ];
                }

                if (mainResult[3] === 'b') {
                    result = [
                        ...result,
                        <b key={result.length}>{mainResult[4]}</b>
                    ];
                }

                if (mainResult[3] === 'u') {
                    result = [
                        ...result,
                        <u key={result.length}>{mainResult[4]}</u>
                    ];
                }

                if (mainResult[3] === "link") {
                    const secondaryRegex = /{link:(.+):(.+)}/;
                    const secondaryResult = secondaryRegex.exec(mainResult[2]);

                    if (secondaryResult) {
                        result = [
                            ...result,
                            <a key={result.length} href={secondaryResult[1]} target="_blank" rel="noopener noreferrer">{secondaryResult[2]}</a>
                        ];
                    } else {
                        result = [
                            ...result,
                            <span key={result.length}>{mainResult[5]}</span>
                        ];
                    }
                }
            }

            if (mainResult[5]) {
                result = [
                    ...result,
                    <span key={result.length}>{mainResult[5]}</span>
                ]
            }

            return result;
        }

        return [htmlString];
    }

    return []
};

export const extractHTMLText = (html, keepHtml = false) => {
    if (html) {
        const htmlStrings = html.split(/\r\n|[\n\v\f\r\x85\u2028\u2029]/);

        if (isArrayWithItems(htmlStrings)) {
            return (
                htmlStrings.map(htmlString => {
                    if (!htmlString) {
                        return "";
                    }

                    let htmlResult = [];

                    htmlResult = [
                        ...htmlResult,
                        ...extractHTMLString(htmlString, keepHtml)
                    ];

                    return htmlResult.join('');
                }).join('\n')
            );
        }
    }
};

export const extractHTMLString = (htmlString, keepHtml = false) => {
    if (htmlString) {
        const mainRegex = /(.*)?({(u|b|i|link):(.+?)})+?(.*)?/;
        const mainResult = mainRegex.exec(htmlString);

        if (mainResult) {
            let result = [];

            if (mainResult[1]) {
                result = [
                    ...result,
                    ...replaceHTMLString(mainResult[1])
                ];
            }

            if (mainResult[2]) {
                if (mainResult[3] === 'i') {
                    result = [
                        ...result,
                        keepHtml ? `<i>${mainResult[4]}</i>` : mainResult[4]
                    ];
                }

                if (mainResult[3] === 'b') {
                    result = [
                        ...result,
                        keepHtml ? `<b>${mainResult[4]}</b>` : mainResult[4]
                    ];
                }

                if (mainResult[3] === 'u') {
                    result = [
                        ...result,
                        keepHtml ? `<u>${mainResult[4]}</u>` : mainResult[4]
                    ];
                }

                if (mainResult[3] === "link") {
                    const secondaryRegex = /{link:(.+):(.+)}/;
                    const secondaryResult = secondaryRegex.exec(mainResult[2]);

                    if (secondaryResult) {
                        result = [
                            ...result,
                            keepHtml ? `<a href=${secondaryResult[1]} target="_blank">${secondaryResult[2]}</a>` : secondaryResult[1]
                        ];
                    } else {
                        result = [
                            ...result,
                            keepHtml ? `<span>${mainResult[5]}</span>` : mainResult[5]
                        ];
                    }
                }
            }

            if (mainResult[5]) {
                result = [
                    ...result,
                    keepHtml ? `<span>${mainResult[5]}</span>` : mainResult[5]
                ]
            }

            return result;
        }

        return [htmlString];
    }

    return [];
};